import React, { Component, useEffect, useState } from 'react';

class Search extends React.Component {
    constructor(props) {
      super(props);
      this.state = {value: ''};
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
      event.preventDefault();
      this.props.setSearch(this.state.value.toLowerCase().replaceAll('_', ' '))
      this.props.setEndpoints([])
      this.props.setView('lists')
    }
  
    render() {
      return (
        <form onSubmit={this.handleSubmit}>
          <label>
            <input type="text" value={this.state.value} onChange={this.handleChange} placeholder="ICD block or endpoint..."/>
          </label>
          <input type="submit" value="Search" />
        </form>
      );
    }
  }

  export default Search